module.exports = __webpack_public_path__ + "static/top_mainimage-fbe5e76929f9ae30bdaac989a322d96b.png";